/**
 * What: "TestFeed connection" section of the Settings page — unchanged from the real settings
 *   page, just re-sectioned here. TestFeedReadinessCard is already an s-* App Home component.
 * Transport / data-flow: Pure presentation; connect/disconnect actions are caller-supplied.
 */
import { productLanguage } from '@testfeed/product-language'
import type { TestFeedConnectionStatus } from '../../../typesStore'
import { TestFeedReadinessCard } from '../../TestFeedReadinessCard'
import type { ActionButtonLifecycle } from '../../ActionButton'

export function ConnectionSection({
  readiness,
  isLoadingReadiness,
  isConnecting,
  isDisconnecting,
  isDisconnectUnconfirmed,
  connectionError,
  planSelectionUrl,
  onConnect,
  onDisconnect,
  lifecycle,
  onRetryCleanup,
}: {
  readiness: TestFeedConnectionStatus | null
  isLoadingReadiness: boolean
  isConnecting: boolean
  isDisconnecting: boolean
  isDisconnectUnconfirmed?: boolean
  connectionError: string | null
  planSelectionUrl?: string
  onConnect: () => void
  onDisconnect: () => void
  lifecycle?: ActionButtonLifecycle<'connect' | 'disconnect' | 'retryCleanup'>
  onRetryCleanup?: () => void
}) {
  const copy = productLanguage.shopify.components.shopifySettingsContent
  return (
    <s-section heading={copy.connectionSectionTitle}>
      <s-text color="subdued">{copy.connectionSectionDescription}</s-text>
      <TestFeedReadinessCard
        key={`${readiness?.externalAccountId}:${readiness?.orgId}:${readiness?.connectionId}:${readiness?.connectionActivatedAt}`}
        readiness={readiness}
        isLoading={isLoadingReadiness}
        isConnecting={isConnecting}
        isDisconnecting={isDisconnecting}
        isDisconnectUnconfirmed={isDisconnectUnconfirmed}
        connectionError={connectionError}
        planSelectionUrl={planSelectionUrl}
        onConnect={onConnect}
        onDisconnect={onDisconnect}
        lifecycle={lifecycle}
        onRetryCleanup={onRetryCleanup}
      />
    </s-section>
  )
}
